import { h } from 'vue'
import { useGlobals } from '@/main.js'
import enums from '@/plugins/enums'
import store from '@/store/index.js'
import { useCurUser } from '@/composables/useCurUser'
import DateHeader from '../../HeaderCells/DateHeader.vue'

const slaDayColor = (slaDays) => {
  if (slaDays === 1) return 'text-blue-6 text-bold'
  if (slaDays >= 2) return 'text-negative text-bold'
  return false
}

export const registerLastCycleStartAtColumn = (dashboard) => {
  const { is: userIs } = useCurUser()
  const { $format } = useGlobals()

  dashboard.registerCustomColumn({
    name: 'last_cycle_start_at',
    label: 'monolith.shared.last_cycle_start_at',
    component: (props) => {
      const lastCycleStartAt = props.row.last_cycle_start_at

      if (!lastCycleStartAt) {
        return null
      }

      const shouldColor =
        userIs.value.valuer &&
        props.row.status === enums.requestStatus.SUBMITTED &&
        props.row.valuation_type === enums.modules.DVM
      const colorClass = shouldColor ? slaDayColor(props.row.sla_days) : ''
      const formattedDate = $format.date(lastCycleStartAt, { timeZone: 'UTC' })

      return h('span', { class: colorClass }, formattedDate)
    },
    options: {
      searchable: store.getters.getConfig.SHOW_DATE_FILTERS,
      headerComponent: DateHeader,
    },
  })
}
